import React, { useMemo } from 'react';
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { getItems, saveItems } from '../../data/items';

const ItemDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const items = useMemo(() => getItems(), []);
  const item = items.find((entry) => String(entry.id) === id);

  if (!item) {
    return <Navigate to="/dashboard/items/not-found" replace />;
  }

  const handleDelete = () => {
    const nextItems = items.filter((entry) => String(entry.id) !== id);
    saveItems(nextItems);
    navigate('/dashboard/items');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button variant="text" startIcon={<ArrowBackIcon />} onClick={() => navigate('/dashboard/items')}>
            Back
          </Button>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {item.name}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" startIcon={<EditIcon />} onClick={() => navigate(`/dashboard/items/${item.id}/edit`)}>
            Edit
          </Button>
          <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={handleDelete}>
            Delete
          </Button>
        </Stack>
      </Stack>

      <Card> 
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">SKU</Typography>
              <Typography variant="h6">{item.sku}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Type</Typography>
              <Typography variant="h6">{item.type}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Stock</Typography>
              <Typography variant="h6">{item.stock}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Unit</Typography>
              <Typography variant="h6">{item.unit}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Selling Price</Typography>
              <Typography variant="h6">{item.sellingPrice}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Purchase Price</Typography>
              <Typography variant="h6">{item.costPrice}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Preferred Vendor</Typography>
              <Typography variant="h6">{item.preferredVendor}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">Description</Typography>
              <Typography variant="h6">{item.description}</Typography>
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />
          <Stack direction="row" spacing={1}>
            <Chip label={item.account} color="primary" variant="outlined" />
            <Chip label={item.purchaseAccount} color="secondary" variant="outlined" />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ItemDetails;
